import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shippingServiceData: {
    id: '',
    routePartner: { id: '', name: '' },
    selectedCountry: '',
    selectedState: '',
    transitDayRange: '',
    shippingServiceType: '',
    wareHouseDetails: { id: '', warehouseName: '' },
    deliveryPartner: { id: '', name: '', partnerType: '' },
    carrierPartner: { id: '', carrierPartnerName: '' },
    createdAt: '',
    updatedAt: '',
    shippingPartner: '',
    shippingId: '',
    rates: [{ minWeight: '', maxWeight: '', pricePerLb: '', buyIn: '' }],
    maxLbPerPackage: '',
    additionalLbPerPackage: '',
    addCustoms: [],
    baseRate: '',
    riskSurcharge: '',
    serviceFees: { doorToDoorFee: '', pickUpFee: '' },
    tracking: false,
    maxDimension: { L: '', W: '', H: '' },
    minimumWeight: '',
    status: '',
    airwayBill: '',
  },
  shippingServices: [],
};

const shippingServiceSlice = createSlice({
  name: 'shippingService',
  initialState,
  reducers: {
    setShippingServiceState(state, action) {
      state.shippingServiceData = {
        ...state.shippingServiceData,
        ...action.payload,
      };
    },
    resetShippingServiceState(state) {
      state.shippingServiceData = { ...initialState.shippingServiceData };
    },
    setShippingServices(state, action) {
      state.shippingServices = action.payload;
    },
  },
});

export const {
  setShippingServiceState,
  resetShippingServiceState,
  setShippingServices,
} = shippingServiceSlice.actions;

export default shippingServiceSlice.reducer; 